var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"staff-queastion"},[_c('my-form',{attrs:{"data":_vm.form,"option":_vm.option,"page-key":"edit","footer-visible":true,"width":"auto"},on:{"submit":_vm.submit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }